<template>
  <slot v-bind="{ createCanvaDesign }"></slot>
</template>

<script>
import find from 'lodash/find' 
import { createDesign, editDesign } from '../../mixins/actions/Canva'
import DocumentStore from '@/frontapp/mixins/DocumentStore'

export default {
  mixins: [
    DocumentStore,
  ],
  data() {
    return {
      currentDesignType: {},
    }
  },
  computed: {
    designType () {
      return this.$formValues['frm-canvaDesignForm-canvaDesignForm-design_type']
    },
    designWidth () {
      return this.$formValues['frm-canvaDesignForm-canvaDesignForm-width']
    },
    designHeight () {
      return this.$formValues['frm-canvaDesignForm-canvaDesignForm-height']
    },
    designUnit () {
      return this.$formValues['frm-canvaDesignForm-canvaDesignForm-unit']
    },
  },
  watch: {
    designType(val) {
      const item = find(this.$controls['frm-canvaDesignForm-canvaDesignForm-design_type']?.items, ['id', val])
      this.currentDesignType = item
      if (!item || item.id === 'Custom') {
        return
      }

      this.$formValues['frm-canvaDesignForm-canvaDesignForm-width'] = item.width
      this.$formValues['frm-canvaDesignForm-canvaDesignForm-height'] = item.height
      this.$formValues['frm-canvaDesignForm-canvaDesignForm-unit:change'] = item.unit
    },
    designWidth(val) {
      if (this.currentDesignType && val != this.currentDesignType.width && this.currentDesignType.id !== 'Custom') {
        this.$formValues['frm-canvaDesignForm-canvaDesignForm-design_type:change'] = 'Custom'
      }
    },
    designHeight(val) {
      if (this.currentDesignType && val != this.currentDesignType.height && this.currentDesignType.id !== 'Custom') {
        this.$formValues['frm-canvaDesignForm-canvaDesignForm-design_type:change'] = 'Custom'
      }
    },
    designUnit(val) {
      if (this.currentDesignType && val != this.currentDesignType.unit && this.currentDesignType.id !== 'Custom') {
        this.$formValues['frm-canvaDesignForm-canvaDesignForm-design_type:change'] = 'Custom'
      }
    },
  },
  methods: {
    createCanvaDesign (/*settings*/) {
      this.$store.commit('nette/updateControl', {
        controlName: 'canvaDesignForm',
        data: false,
        key: 'showModal',
      })

      let promise
      let canvaDesign
      if (this.$formValues['frm-canvaDesignForm-canvaDesignForm-design'] != '') {
        canvaDesign = {
          design_id: this.$formValues['frm-canvaDesignForm-canvaDesignForm-design'],
          file_type: this.$formValues['frm-canvaDesignForm-canvaDesignForm-file_type'],
        }

        promise = editDesign(
          this.$formValues['frm-canvaDesignForm-canvaDesignForm-design'],
          this.$formValues['frm-canvaDesignForm-canvaDesignForm-file_type'],
          this.$controls['canvaDesignForm'].document
        )
      
      } else {
        canvaDesign = {
          type: this.$formValues['frm-canvaDesignForm-canvaDesignForm-design_type'],
          file_type: this.$formValues['frm-canvaDesignForm-canvaDesignForm-file_type'],
          width: this.$formValues['frm-canvaDesignForm-canvaDesignForm-width'],
          height: this.$formValues['frm-canvaDesignForm-canvaDesignForm-height'],
          unit: this.$formValues['frm-canvaDesignForm-canvaDesignForm-unit'],
        }

        promise = createDesign(
          this.$formValues['frm-canvaDesignForm-canvaDesignForm-design_type'],
          this.$formValues['frm-canvaDesignForm-canvaDesignForm-file_type'],
          this.$formValues['frm-canvaDesignForm-canvaDesignForm-width'],
          this.$formValues['frm-canvaDesignForm-canvaDesignForm-height'],
          this.$formValues['frm-canvaDesignForm-canvaDesignForm-unit'],
          this.$controls['canvaDesignForm'].document
        )
      }

      promise.then(({ file, document, designId }) => {
        if (!file) {
          return
        }

        document.updateCanvaDesign(
          canvaDesign,
          {
            parent__bc_document_data_rev_id: document.elementId,
            type: 'file',
            data: {
              name: '',
              canva: true,
              can_download: true,
              public_upload: false,
              file_id: file.id,
              canva_design: {
                ...canvaDesign,
                design_id: designId,
                file_type: file.ext
              }
            },
            file,
            rank: document.childrenLength,
            //updated: true,
            key: Math.random()
              .toString(36)
              .replace(/[^a-z]+/g, '')
              .substr(0, 5)
          }
        )

      })

      return false
    }
  }
}
</script>